import React from 'react';
import { useTitle } from "fearless-common-ui";
import {Badge} from "react-bootstrap";
import {Pages} from "../components/layout";
import styles from './SignUpSuccess.module.scss';
import {isDev} from "../utils/env";
import Description from "../components/Description";

/**
 * The page the user arrives at after signing up successfully.
 */
export default function SignUpSuccess() {
    useTitle('Welcome to the Fearless League');

    return (
      <Pages.Centred width="xs" className="text-center">
        <h1 className="mb-3">Almost done!</h1>
        <Description>Please verify your email to complete your sign up.</Description>

        {isDev() && (
          <>
            <div className="d-flex align-items-start justify-content-center">
              {[{ label: 'MailHog', icon: <div>MailHog<br/><Badge>Dev only</Badge></div>, website: 'http://localhost:8025' }].map(({
                                                                                                       icon,
                                                                                                       website,
                                                                                                       label
                                                                                                     }) => (
                <div key={label} className="px-4">
                  <div className={`${styles.IconContainer} d-flex align-items-center justify-content-center mb-3`}>
                    {icon}
                  </div>
                  {website &&
                      <a className="btn btn-outline-light" href={website} target="_blank" rel="noreferrer">Go to {label} website</a>}
                </div>
              ))}
            </div>
          </>
        )}
      </Pages.Centred>
    );
}
